<div class="flex gap">
    <app-check-input
        [form]="form"
        id="active"
        [prefix]="prefix"
    ></app-check-input>

    <app-text-input
        [form]="form"
        id="name"
        [prefix]="prefix"
    ></app-text-input>

    <app-text-input
        [form]="form"
        id="description"
        [prefix]="prefix"
    ></app-text-input>
</div>
